// ** Toolkit imports
import { configureStore } from "@reduxjs/toolkit";

// ** Reducers
import chat from "./apps/chat";
import isMicOn from "./apps/mic";
import user from "./apps/user";
import appearance from "./apps/appearance";

export const store = configureStore({
  reducer: {
    chat,
    isMicOn,
    user,
    appearance,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
